export const BOARD_VALUE = 'board';
export const CREATE_JOB_APPLICATION_FINAL_STEP = 6;
export const DEFAULT_SORT_JOB_APPLICATIONS = '-appliedTime';
export const DEFAULT_CURRENT_PAGE = 1;
export const LIMIT_ITEM = 10;
export const YOUTUBE_VALUE = 'youtube';
